;(function () {
  window.Ateed.Components.DatePicker = function() {
    var startDate = moment();
    var endDate = moment().add(14, 'days');

    var minDate = new Date();
    minDate.setMonth(minDate.getMonth()-1);

    $('.date-range-wrapper').daterangepicker({
        locale: {
          format: 'DD MMM YYYY'
        },
        startDate: startDate,
        endDate: endDate,
        opens: 'right',
        minDate: minDate
    }).on('hide.daterangepicker', function (event, picker) {
      $('.date-range-wrapper .from .date-range-picker-value')
        .text(picker.startDate.format('DD MMM YYYY'));
      $('.date-range-wrapper .to .date-range-picker-value')
        .text(picker.endDate.format('DD MMM YYYY'));
    });

    $('.date-range-wrapper .from .date-range-picker-value')
      .text(startDate.format('DD MMM YYYY'));
    $('.date-range-wrapper .to .date-range-picker-value')
      .text(endDate.format('DD MMM YYYY'));
  };
})();
